import { format, isValid } from 'date-fns';

import { parseDate } from '../../utils/datetime';

export const PublishedAt = ({ date }: { date: string }) => {
  const day = parseDate(date);

  if (!day || isValid(new Date(day)) === false) return null;

  return <time dateTime={date}>{format(day, 'MMMM dd, yyyy')}</time>;
};
